import React from 'react';
import './App.css';
import Main from './Pages/Main/Main';


function App() {
  return ( 
    <>
    <Main />
    </>
  );
}

export default App;
